import { Box } from "@mui/material";
import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import Dashboard from "./Dashboard";
import { useUserContext } from "../contexts/UserContext";

export default function ReportBubbles({ excludedPermissions = [] }: { excludedPermissions?: string[] }) {
  const { user, isUserLoading } = useUserContext();
  const [permissions, setPermissions] = useState<string[]>([]);
  const [internalUserIds, setInternalUserIds] = useState<number[]>([]);
  const visiblePermissions = useMemo(
    () => permissions.filter((permission) => !excludedPermissions.includes(permission)),
    [excludedPermissions, permissions]
  );

  useEffect(() => {
    const getUserReportPermissions = async (id: number) => {
      const { data } = await axios.get<string[]>(
        `/api/clientphonebook/dashboardReportPermissions/GetReportPermissionsForInternalUser?id=${id}`
      );
      setPermissions(data);
    };

    const getAssignableInternalUserIds = async () => {
      const { data } = await axios.get<number[]>("/api/orders/getAssignableInternalUserIds");
      setInternalUserIds(data);
    };

    if (!user?.id) {
      setPermissions([]);
      setInternalUserIds([]);
      return;
    }

    getUserReportPermissions(user.id);
    getAssignableInternalUserIds();
  }, [user?.id]);

  if (isUserLoading || !user?.id || visiblePermissions.length === 0 || internalUserIds.length === 0) {
    return null;
  }

  return (
    <Box display="flex" justifyContent="center" width="100%">
      <Dashboard internalUserIds={internalUserIds} permissions={visiblePermissions} />
    </Box>
  );
}
